export const GET_HOLIDAYS_REQUEST = 'GET_HOLIDAYS_REQUEST';
export const ADD_HOLIDAY_REQUEST = 'ADD_HOLIDAY_REQUEST';
export const EDIT_HOLIDAY_REQUEST = 'EDIT_HOLIDAY_REQUEST';
export const DELETE_HOLIDAY_REQUEST = 'DELETE_HOLIDAY_REQUEST';

export const getHolidays = (params, callback) => ({
    type: GET_HOLIDAYS_REQUEST,
    payload: { params, callback }
});

export const addHoliday = (date, name, description, callback) => ({
    type: ADD_HOLIDAY_REQUEST,
    payload: { date, name, description, callback }
});

export const editHoliday = (id, date, name, description, callback) => ({
    type: EDIT_HOLIDAY_REQUEST,
    payload: { id, date, name, description, callback }
});

export const deleteHoliday = (id, callback) => ({
    type: DELETE_HOLIDAY_REQUEST,
    payload: { id, callback }
});
